"use client";
import React from "react";
import Image from "next/image";
import home from "@/public/images/home.svg";
import leftArrow from "@/public/images/leftArrow.svg";
import view from "@/public/images/view.svg";
import time from "@/public/images/time.svg";
import latest from "@/public/images/latest.svg";
import { Blog } from "@/types/blog";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { format } from "date-fns";
import { ar, enUS } from "date-fns/locale";
import { formatNumber } from "@/utils/format viwes number/formatNumber";

const Index = ({ blog }: { blog: Blog }) => {
  const { locale }: { locale: "ar" | "en" } = useTranslate();
  const lang: "ar" | "en" = locale as "ar" | "en";

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return format(date, "EEEE، d MMMM yyyy", {
      locale: lang === "ar" ? ar : enUS,
    });
  };

  return (
    <div className="container flex flex-col md:flex-row gap-5 py-[30px]">
      <div className=" flex items-center justify-center bg-white border border-[#EBEBEB] rounded-[10px]  p-5 md:min-w-[350px] md:max-w-[400px]">
        <Image
          src={blog.image[locale] || ""}
          alt={blog.title[lang]}
          width={350}
          height={300}
          className="h-auto w-full rounded-[10px] object-cover"
          // layout="responsive"
        />
      </div>
      <div className="w-full flex flex-col gap-5">
        <div className="flex items-center gap-3">
          <Image src={home} alt="home" />
          <p className="text-12 text-descriptionText">
            {lang === "ar" ? "الرئيسية" : "Home"}
          </p>
          <Image src={leftArrow} alt="leftArrow" />
          <p className="text-12 text-descriptionText">
            {lang === "ar" ? "المقالات" : "Articles"}
          </p>
          <Image src={leftArrow} alt="leftArrow" />
          <p className="text-12 text-descriptionText line-clamp-1">
            {blog.title[lang]}
          </p>
        </div>
        <p className="text-20 text-darkText font-[500]">{blog.title[lang]}</p>
        <p className="text-18 text-descriptionText line-clamp-4">
          {blog.short_description[lang]}
        </p>
        <div className="flex items-center gap-3 flex-wrap">
          {blog.tags.map((tag, index) => (
            <p
              key={index}
              className="text-14 text-descriptionText bg-white w-fit py-2 px-7 rounded-full"
            >
              {tag[lang]}
            </p>
          ))}
        </div>
        <div className="w-full flex items-center justify-between gap-5 flex-wrap">
          <div className="flex items-center gap-3">
            <Image src={view} alt="view" />
            <p className="text-16 text-descriptionText font-[500]">
              {formatNumber(blog?.views)} {lang === "ar" ? "مشاهدة" : "views"}
            </p>
          </div>
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-3">
              <Image src={time} alt="time" />
              <div>
                <p className="text-16 text-darkText">
                  {lang === "ar"
                    ? "تاريخ انشاء المقالة"
                    : "Article Creation Date"}
                </p>
                <p className="text-14 text-descriptionText">
                  {formatDate(blog.created)}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Image src={latest} alt="time" />
              <div>
                <p className="text-16 text-darkText">
                  {lang === "ar" ? "آخر تحديث للمقالة" : "Last Article Update"}
                </p>
                <p className="text-14 text-descriptionText">
                  {formatDate(blog.updated)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
